import { Select } from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import personRoleFetcherHoc from "@hocs/personRoleFetcherHoc";
import {FormattedMessage} from 'react-intl';
import {PersonRole} from "@models/person-role";


const Option = Select.Option;


type SelectionValue = string | string[] | null


type VideoSelectionProps = {
    mode : SelectionMode,
    onChange?:(value:SelectionValue)=>void
    value:SelectionValue
    data:PersonRole[],
    selectedPersonRole:PersonRole | null,
    onScroll:(e:SyntheticEvent)=>void,
    handleSearch:(query:string)=>void,
    onFocus:()=>void
}

const VideoSelection:React.FC<VideoSelectionProps> = props => {
    const {mode, handleSearch, onScroll, data = [], onChange, onFocus,selectedPersonRole,disabled} = props;
    const defaultValue = mode == SelectionMode.DEFAULT ? null : [];
    const [value, setValue] = useState(defaultValue);
    //the selected items should be in the data of select to show correctly
    const list = selectedPersonRole && !data.find(opt => opt.id == selectedPersonRole.id) ? [...data, selectedPersonRole] : data;

    useEffect(() => {
        if (selectedPersonRole) {
            setValue(selectedPersonRole.id)
        }
    }, [props.selectedPersonRole]);

    const handleChange = value => {
        setValue(value);
        onChange && onChange(data.find( item => item.id == value));
    };

    return (
        <Select
            showSearch
            disabled={disabled}
            mode={'default'}
            value={value}
            defaultActiveFirstOption={false}
            showArrow={true}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleChange}
            onFocus={onFocus}
            onPopupScroll={onScroll}
            notFoundContent={null}
            // placeholder={ <FormattedMessage id="app.select_role" defaultMessage={`Select Role`}/>}
        >
            {list.map((d, index) => <Option value={d.id} key={index}>{d.title}</Option>)}
        </Select>
    );
}


export default personRoleFetcherHoc(VideoSelection);
